"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutate = void 0;
const _1 = require(".");
const error_handler_1 = require("../error-handler");
const mutate = async (mutation, { variables, }) => {
    const result = await _1.client.mutate({
        mutation,
        variables,
    });
    if (result.errors) {
        console.log('API request returned some errors:');
        console.log(JSON.stringify({ errors: result.errors, variables, mutation }, null, 2));
    }
    return ({
        data: result.data,
        errors: result.errors ? (0, error_handler_1.reduceErrors)(result.errors) : undefined,
    });
};
exports.mutate = mutate;
